import React from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { environment } from './Environment';
import Index from './components/Landing/Index';
import NavigationBar from './components/Landing/Navigation/NavigationBar';
import Catalogue from './components/Catalogue';
import Account from './components/Account';
import SignIn from './components/Session/SignIn';
import SignUp from './components/Session/SignUp';
import PrivateRoute from './PrivateRoute';
import ForgotPassword from './components/Session/ForgotPassword';
import ResetPassword from "./components/Session/ResetPassword";
import TermsOfUse from "./components/Landing/TermsOfUse";
import PrivacyPolicy from "./components/Landing/PrivacyPolicy";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'react-toastify/dist/ReactToastify.min.css';

const App = () => {
    return (
        <RelayEnvironmentProvider environment={environment}>
            <Router>
                <ToastContainer />
                <NavigationBar />
                <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/sign-in" element={<SignIn />} />
                    <Route path="/sign-up" element={<SignUp />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/catalogue/:category" element={<Catalogue />} />
                    <Route path="/catalogue" element={<Navigate to="/catalogue/full-collection" replace />} />

                    <Route
                        path="/account/*"
                        element={
                            <PrivateRoute>
                                <Account />
                            </PrivateRoute>
                        }
                    />

                    {/* Catch-all route for unknown paths, redirect to home */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </RelayEnvironmentProvider>
    );
}

export default App;
